var btoa = require("btoa");
var landingLogo = btoa("\n  <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 522 132\"><defs><style>.a{fill:#d95e00;}</style></defs><title>vimana-01</title><path class=\"a\" d=\"M299.76,36.25l28.49,60.2H311.4L299.86,71.29h-.31L288,96.45H271.27Zm165.51,0,28.49,60.2H476.91L465.37,71.29h-.31L453.52,96.45H436.78ZM123,39.06h15.59V96.55H123Zm87.23,20.79,30.67-23.6v60.2H225.32V68.17h-.42L210.35,79.71,195.79,68.17h-.42V96.45H179.78V36.25Zm164,11.44h-.42V96.45H358.18V36.25l32.54,28h.42V39.06h15.59v60.2Zm-311,28L34.75,39.06H51.59L63.13,64.22h.31L75,39.06H91.72Z\"/></svg>\n");
var squareLogo = btoa("<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 132 132\"><defs><style>.a{fill:#d95e00;}</style></defs><title>vv</title><path class=\"a\" d=\"M63.23,99.29,34.75,39.06H51.59L63.13,64.22h.31L75,39.06H91.72Z\"/></svg>");
var workspaceBackgroundImage = btoa("<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" width=\"16\" height=\"16\"><circle cx=\"1\" cy=\"1\" r=\"1\" fill=\"rgba(0, 0, 0, 0.3)\"></circle></svg>");
module.exports = {
  themeName: "vimana",
  brandName: "vimana",
  bodyClassName: "vimana-theme",
  documentationURL: "url(https://systeminsights.jira.com/servicedesk/customer/kb/view/381943824)",
  // Color overrides
  "dark-gray4": "#3f424a",
  "dark-gray5": "rgb(48, 51, 58)",
  // Intents
  "bp6-intent-primary": "#137cbd",
  "bp6-intent-primary-disabled": "#137cbd80",
  "bp6-intent-success": "#0f9960",
  "bp6-intent-warning": "#d9822b",
  "bp6-intent-danger": "#db3737",
  "bp6-app-background-color": "#f5f8fa",
  "bp6-dark-app-background-color": "#293742",
  // Colors
  colorDarkRed: "#db3737",
  // App styles follow.
  fontSizeXXXS: "10px",
  fontSizeXXS: "11px",
  fontSizeXS: "12px",
  fontSizeSmall: "14px",
  fontSizeMedium: "16px",
  fontSizeLarge: "18px",
  fontSizeXL: "22px",
  fontSizeXXL: "28px",
  fontWeightHeavy: "600",
  fontStyleItalic: "italic",
  color: "black",
  mutedColor: "#8b9298",
  disabledTextColor: "#d8d8d8",
  linkColor: "#106ba3",
  background: "white",
  selectedColor: "#115365",
  selectedBorderColor: "#26bbe4",
  selectedBackground: "#d9e9ff",
  disabledBackground: "#e6e6e6",
  borderColor: "rgba(88, 107, 119, 0.1)",
  toolbarBorderColor: "rgba(88, 107, 119, 0.1)",
  inverseTextColor: "#ebf1f5",
  inverseButtonColor: "#182026",
  inverseButtonBackground: "linear-gradient(to bottom, #ffffff, rgba(255, 255, 255, 0)) left no-repeat, center no-repeat #f5f8fa",
  inverseBackgroundColor: "#4d5057",
  inverseLinkColor: "#fff",
  padding: "1rem",
  paddingSmall: "0.75rem",
  paddingLarge: "2rem",
  margin: "1rem",
  marginSmall: "0.75rem",
  marginLarge: "2rem",
  DataOnDemandJobStatusCompleteTagColor: "$bp6-intent-success",
  DataOnDemandJobStatusFailedTagColor: "$bp6-intent-danger",
  DataOnDemandJobStatusInProgressTagColor: "$bp6-intent-warning",
  SidebarPrimaryBG: "#13161d",
  SidebarTypesBackground: "#30333a",
  SidebarTypeLabelBackground: "#676a71",
  SidebarMoreDetailsColor: "#9a9da4",
  SidebarPrimaryText: "#e6e9f0",
  tabIndicatorColor: "$bp6-intent-primary",
  minimalButtonText: "$bp6-intent-primary",
  ProducingStateColor: "rgb(111,195,118)",
  SetupStateColor: "rgb(205,165,205)",
  StandbyStateColor: "rgb(177,218,174)",
  UnplannedDowntimeStateColor: "rgb(246,146,143)",
  PlannedDowntimeStateColor: "rgb(251,188,109)",
  DataUnavailableStateColor: "rgb(193,193,193)",
  ShutdownStateColor: "rgb(93,165,218)",
  ScreenBackground: "$bp6-app-background-color",
  DarkScreenBackground: "$bp6-dark-app-background-color",
  DeviceStatusOverlayBackground: "rgba(255, 255, 255, 0.8)",
  DataTableMessageColor: "#ebf1f5",
  DataTableMessageBackground: "#30333a",
  NavbarHeight: "48px",
  NavbarColor: "#ebf1f5",
  NavbarBackground: "#30333a",
  NavbarBackgroundTheme: "dark",
  AIChatDialogPopupTheme: "bp6-dark",
  NavbarPadding: "0 15px",
  NavbarCollapseWidth: "1024px",
  NavbarCompactWidth: "767px",
  NavbarSubTitleColor: "#9a9da4",
  NavbarBorderColor: "$borderColor",
  SidebarWidth: "48px",
  SidebarLogoHeight: "48px",
  SidebarIconHeight: "48px",
  SidebarIconWidth: "48px",
  SidebarIconMargin: "0px",
  SidebarExpandedWidth: "190px",
  SidebarTransitionDuration: "0.25s",
  SidebarLinkColor: "white",
  SidebarLinkFontWeight: "400",
  SidebarBackground: "black",
  SidebarHoverBackground: "linear-gradient(\n    to left,\n    rgba(0, 0, 0, 0.75) 0%,\n    rgba(0, 0, 0, 1) 75%\n  )",
  SidebarActiveColor: "white",
  SidebarIconHoverColor: "#ffffff",
  SidebarIconHoverBackground: "#4d5057",
  SidebarIconActiveBackground: "#d95e00",
  SidebarBorderRight: "rgba(0, 0, 0, 0) 0%",
  SidebarIconBorderBottom: "rgba(0, 0, 0, 0) 0%",
  BrowserStatusBarHeight: "20px",
  HeaderColor: "$color",
  HeaderBackground: "transparent",
  HeaderBorderColor: "$borderColor",
  ToolbarHeight: "48px",
  ToolbarTextColor: "$mutedColor",
  ToolbarBackground: "#f5f8fa",
  ToolbarHoverBackground: "#dbe6ee",
  SecondaryToolbarTextColor: "$color",
  SecondaryToolbarBackground: "#cfd2d9",
  WorkspaceBackground: "rgba(0, 0, 0, 0.1) url(\"data:image/svg+xml;base64," + workspaceBackgroundImage + "\") repeat -1px 0px",
  SidePanelTextColor: "$ToolbarTextColor",
  SidePanelBackground: "#f5f8fa",
  FooterColor: "white",
  FooterBackground: "linear-gradient(to bottom, #dadada 0%, #ffffff 50%)",
  FooterBorderColor: "transparent",
  FootTextColor: "$inverseTextColor",
  ContentColor: "$color",
  ContentBackground: "$background",
  ContentPadding: "$padding",
  TextColor: "$color",
  MutedTextColor: "$mutedColor",
  DisabledText: "$disabledTextColor",
  TagTextColor: "#13161d",
  TagBackgroundColor: "#8A9BA8",
  ScheduleCurrentTagTextColor: "#0d8050",
  ScheduleFutureTagTextColor: "#106ba3",
  ScheduleCurrentTagBackgroundColor: "rgba(15, 153, 96, 0.15)",
  ScheduleFutureTagBackgroundColor: "rgba(19, 124, 189, 0.15)",
  LeadTextColor: "#6e6e6e",
  LeadTextFontSize: "$fontSizeLarge",
  HeadingColor: "$color",
  HeadingMargin: "$padding",
  HeadingSmallColor: "rgba(0, 0, 0, 0.3)",
  ButtonColor: "black",
  ButtonBackground: "#e5e6e8",
  ButtonBorderColor: "#d8d6d6",
  ButtonPadding: "0.75rem 1rem",
  ButtonPaddingSmall: "0.5rem 0.75rem",
  ButtonPaddingLarge: "1.25rem 1.5rem",
  SecondaryButtonColor: "#444",
  SecondaryButtonBackground: "white",
  PanelColor: "$color",
  PanelBackground: "$background",
  PanelSecondaryBackground: "$inverseTextColor",
  PanelBorder: "solid 1px rgba(0, 0, 0, 0.1)",
  PanelPadding: "$padding",
  PanelHeaderColor: "$HeaderColor",
  PanelHeaderBackground: "$background",
  PanelHeaderBorder: "solid 1px rgba(0, 0, 0, 0.1)",
  ListItemColor: "$linkColor",
  ListItemBackground: "transparent",
  ListItemBackgroundDisabled: "$disabledBackground",
  ListItemBackgroundHover: "$selectedBackground",
  ListItemBorderColor: "$borderColor",
  SettingsMenuActiveBackground: "white",
  SelectedListItemColor: "$selectedColor",
  SelectedListItemBackground: "$selectedBackground",
  SelectedListItemBorderColor: "$selectedBorderColor",
  ClassificationButtonPadding: "0.75rem 1rem 1rem",
  CycleListItemColor: "$color",
  CycleListItemBackground: "$background",
  CycleListItemBorderColor: "$borderColor",
  CycleListItemButtonPadding: "0.2rem 0 0 0.8rem",
  CycleListItemHeadingMargin: "0 0 5px 0",
  SelectedCycleListItemColor: "$selectedColor",
  SelectedCycleListItemBackground: "$selectedBackground",
  SelectedCycleListItemBorderColor: "$selectedBorderColor",
  RightEditPanelTextColor: "$color",
  RightEditPanelBackground: "#fff",
  DeviceSelectorButtonBorder: "2px solid #d8d6d6",
  SelectedDeviceSelectorButtonBorder: "2px solid #26bbe4",
  SelectorHeadingMargin: "0 0 10px 0",
  DeviceSelectorButtonColor: "$ButtonColor",
  SelectedDeviceSelectorButtonColor: "$selectedColor",
  DeviceSelectorButtonBackground: "$ButtonBackground",
  SelectedDeviceSelectorButtonBackground: "$selectedBackground",
  CreateButtonColor: "#66ffcc",
  CreateButtonBorderColor: "#085a45",
  CreateButtonBackground: "#0f9c8b",
  CreateButtonHoverBackground: "#078676",
  ThumbnailListItemColor: "$color",
  ThumbnailListItemBackground: "$background",
  ThumbnailListItemShadow: "#cfd2d9",
  ThumbnailListItemBorderRadius: "5px",
  ThumbnailListItemBackgroundHover: "#1678c2",
  ThumbnailListItemLabelBackground: "$background",
  ThumbnailListItemBorderColor: "$borderColor",
  ThumbnailListItemBorderColorHover: "$borderColor",
  SelectedThumbnailListItemColor: "$selectedColor",
  SelectedThumbnailListItemBackground: "$selectedBackground",
  SelectedThumbnailListItemBorderColor: "$selectedBorderColor",
  SelectedThumbnailListItemShadow: "#676a71",
  SliderTrackBorderRadius: "3px",
  SliderTrackTop: "5px",
  SliderHandleBackground: "#f5f8fa",
  SliderHandleBackgroundHover: "#f5f8fa",
  SliderHandleBorder: "#13161d",
  SliderHandleBorderRadius: "3px",
  SliderHandleBorderSize: "0px",
  SliderHandleWidth: "16px",
  SliderHandleHeight: "16px",
  SliderProgressHeight: "6px",
  SliderProgressBackground: "$bp6-intent-primary",
  SliderProgressDarkBackground: "#5c708033",
  SliderProgressDarkBackgroundHeight: "6px",
  WidgetPaletteTextColor: "$color",
  WidgetPaletteBackground: "$ToolbarBackground",
  RequiredLabelColor: "#ab2020",
  TableBackground: "#e6e9f0",
  TableBoxShadowColor: "#adadad",
  TableSelectedRegionBackground: "rgba(1, 1, 1, .1)",
  TableBorderTopColor: "#f6f6f6",
  DefaultTagColor: "$color",
  DefaultTagBackground: "$ToolbarBackground",
  FormErrorColor: "#c23030",
  LandingAppIconColor: "#E6E9F0",
  LandingLogo: "url(data:image/svg+xml;base64," + landingLogo + ")",
  SquareLogo: "url(data:image/svg+xml;base64," + squareLogo + ")",
  // $FlowFixMe
  PoweredByLogo: false,
  BrushHandleEdgeBackground: "#676a71",
  BrushHandleBackground: "#30333a",
  BrushHandleColor: "$inverseTextColor",
  BrushBorder: "#30333a",
  BrushColor: "$inverseButtonColor",
  BrushBackgroundColor: "$inverseTextColor",
  SelectionModeBackgroundColor: "#CCCCCC",
  SelectionModeColor: "#000000",
  ChartTitleColor: "black",
  ChartStrokeColor: "#1678c2",
  ToolTipHandleColor: "red",
  TooltipTextBackground: "#CCC",
  TooltipContentBorderBottomColor: "#b7b7b7",
  TooltipContentColor: "#52545C",
  TooltipContentBackgroundColor: "#E3E9F0",
  TimeLineInstanceColor: "#afafaf",
  TimeLineProcessColor: "#afafaf",
  TimeLineKindColor: "#afafaf",
  TimeLineShiftColor: "#5da5da",
  LogbookCommentFillColor: "#8C9BC0",
  LogbookTicketFillColor: "#f9ea96",
  LogbookHeaderBackground: "$ToolbarBackground",
  LogbookBackground: "$background",
  LogbookMutedTextColor: "$mutedColor",
  LogbookBorderColor: "$borderColor",
  LogBookNewEventBackground: "$SidePanelBackground",
  LogbookItemPadding: "0.2rem 0 0 0.8rem",
  LogbookHeaderHeight: "48px",
  LogbookFiltersHeight: "98px",
  TicketDetailsBackground: "$NavbarColor",
  AppHomeScreenColor: "$inverseTextColor",
  AppHomeScreenBackground: "radial-gradient(circle at center center, #13161D 0px, #000000 70%)",
  PlantTwinSearchMatchingHighlightColor: "#FC6421",
  PlantTwinLineBackground: "#F2F2F2",
  PlantTwinDeviceBackground: "#F2F2F2",
  PlantTwinAccordionColor: "#FFFFFF",
  PlantTwinCollapseFillColor: "#D95E00",
  PlantTwinExpandFillColor: "#D95E00",
  LandingScreenColor: "#000000",
  LandingScreenTextColor: "#000000",
  DefaultValueCustomColor: "#fbbc6d",
  LandingPageTextColor: "#E6E9F0",
  SettingsIconColor: "#ffffff",
  NavbarBackgroundColor: "#30333a",
  CategorySeparatorHorizontalPadding: "16px",
  KBToolbarBackground: "#f5f8fa",
  KBHeaderHeight: "48px",
  KBToolbarHeight: "48px",
  KBListItemArticleHeight: "50px",
  KBListItemPageHeight: "39px",
  KBBreadCrumbContainerHeight: "24px",
  KBWorkInstructionBoxShadow: "rgba(0, 0, 0, 0.2) 0px 2px 1px -1px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 1px 3px 0px;",
  KBAddPageLinkContainerWidth: "432px",
  KBAddPageLinkContainerHeight: "315px",
  KBFontSizeDropdownWidth: "150px",
  KBPageLinkBackground: "#575757",
  KBBlockquoteBackground: "#f9f9f9",
  KBBlockquoteLeftBorder: "#CCC",
  KBPageLinkCaretColor: "#FFF",
  KBArticleDetailsHeight: "125px",
  KBTriggerPanelHeight: "150px",
  KBPageTitleHeight: "100px",
  KBRTEToolbarHeight: "30px",
  DropdownTextWidthFactor: "7.3",
  DropdownLabelWidthFactor: "6.5",
  DTBorderColor: "#ccc",
  DTSearchMatchingHighlightColor: "#FC6421",
  DTLineBackground: "#F2F2F2",
  DTDeviceBackground: "#F2F2F2",
  DTAccordionColor: "#FFFFFF",
  DTCollapseFillColor: "#56b33b",
  DTExpandFillColor: "#56b33b",
  DefaultChartColor: "#1678c2",
  TooltipCursorFillColor: "#ddd",
  ChartBrushColor: "#777",
  backgroundSize: "inherit",
  // Tokens the modern UI introduced. These values reproduce the legacy look,
  // so the components that read them render as before until the modern
  // overlay (Components/Theme/UiDesign/modernOverlay.js) replaces them.
  NavbarTitleFontSize: "$fontSizeXXL",
  NavbarTitleFontWeight: "300",
  FontFamilySans: "inherit",
  FontFamilyHeading: "sans-serif",
  ChartFontFamilyMono: "inherit",
  ChartTrackColor: "transparent",
  ChartGridColor: "$toolbarBorderColor",
  ChartAxisTextColor: "$TextColor",
  ChartLegendTextColor: "$TextColor",
  ChartDividerColor: "#000000",
  ChartBarRadius: "0px",
  ChartCardBackground: "#ffffff",
  ChartCardBorderColor: "$borderColor",
  ChartCardRadius: "0px",
  CardShadow: "none",
  CardShadowRaised: "none",
  ButtonShadow: "none",
  ButtonShadowHover: "none",
  ChartCardTitleColor: "$color",
  ChartCardSubtitleColor: "$mutedColor",
  ChartCardChipBackground: "$ToolbarBackground",
  ChartCardChipColor: "$color",
  KpiLabelColor: "$color",
  KpiValueColor: "$color",
  ChartTooltipBorderColor: "rgba(16, 22, 26, 0.1)",
  ChartTooltipShadow: "0 2px 4px rgba(16, 22, 26, 0.2), 0 8px 24px rgba(16, 22, 26, 0.2)"
};